import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Title, Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SlickCarouselComponent } from 'ngx-slick-carousel';
import { ToastrService } from 'ngx-toastr';
import { UtilityService } from 'src/app/services/utility.service';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';
import { Modal } from 'bootstrap';

declare var $: any;
declare var jQuery: any;

interface ShippingFeature {
  icon: string;
  title: string;
  description: string;
  colorClass: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  // private modal: Modal | undefined;

  // openModal() {
  //   const modalEl = document.getElementById('exampleModal');
  //   if (modalEl) {
  //     this.modal = new Modal(modalEl);
  //     this.modal.show();
  //   }
  // }

  // closeModal() {
  //   if (this.modal) {
  //     this.modal.hide();
  //   }
  // }

  phoneNumbers = {
    US: { label: 'US (Toll Free)', display: '+1 (800) 883-1998', tel: '+18008831998' },
    CA: { label: 'Canada (Toll Free)', display: '+1 (888) 721-5298', tel: '+18887215298' },
    PH: { label: 'PH (Calls Only)', display: '+63 930 226 7580', tel: '+63930226758' },
    };

  visiblePhones: any[] = [];


  @ViewChild('slickModal') slickModal: SlickCarouselComponent;
  invoiceFormControl: FormControl;

  slides = [
    { img: 'assets/img/services/logistics-320x200.jpg' },
    { img: 'http://placehold.it/350x150/111111' },
    { img: 'http://placehold.it/350x150/333333' },
    { img: 'http://placehold.it/350x150/666666' },
  ];

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1500,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  features: ShippingFeature[] = [
    {
      icon: 'bi-currency-dollar',
      title: 'Affordable Flat Rates',
      description: 'Transparent pricing with no hidden fees',
      colorClass: 'feature-green',
    },
    {
      icon: 'bi-shield-check',
      title: 'Professional Service',
      description: 'Expert handling with guaranteed reliability',
      colorClass: 'feature-blue',
    },
    {
      icon: 'bi-truck',
      title: 'Fast Ocean Transit',
      description: 'Optimized routes for quickest delivery',
      colorClass: 'feature-purple',
    },
    {
      icon: 'bi-phone',
      title: 'Box Tracking via Mobile App',
      description: 'Track your shipments anytime, anywhere',
      colorClass: 'feature-orange',
    },
    {
      icon: 'bi-person-check',
      title: 'No Third Party Service',
      description: 'Direct service with full accountability',
      colorClass: 'feature-teal',
    },
    {
      icon: 'bi-geo-alt',
      title: 'Real-time Tracking',
      description: 'Live updates on your shipment location',
      colorClass: 'feature-pink',
    },
  ];

  website_config: any = JSON.parse(localStorage.getItem('website_config'));
  images: any = JSON.parse(localStorage.getItem('res_images'));
  partners: any = JSON.parse(localStorage.getItem('res_partners'));

  constructor(
    public utilityService: UtilityService,
    private dataService: DataService,
    private router: Router,
    private toastr: ToastrService,
    private title: Title,
    private meta: Meta
  ) {
    this.website_config;
  }

  ngOnInit() {
    $('.sigma_banner-slider').slick({
      autoplay: true,
      autoplaySpeed: 5000,
    });

    $('.sigma_team-slider').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      slideConfig: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    });

    this.countJs();

    this.invoiceFormControl = new FormControl('');
    this.setVisiblePhones();
  }

  countJs() {
    (function ($) {
      $.fn.countTo = function (options) {
        // merge the default plugin settings with the custom options
        options = $.extend({}, $.fn.countTo.defaults, options || {});

        // how many times to update the value, and how much to increment the value on each update
        var loops = Math.ceil(options.speed / options.refreshInterval),
          increment = (options.to - options.from) / loops;

        return $(this).each(function () {
          var _this = this,
            loopCount = 0,
            value = options.from,
            interval = setInterval(updateTimer, options.refreshInterval);

          function updateTimer() {
            value += increment;
            loopCount++;
            $(_this).html(value.toFixed(options.decimals));

            if (typeof options.onUpdate == 'function') {
              options.onUpdate.call(_this, value);
            }

            if (loopCount >= loops) {
              clearInterval(interval);
              value = options.to;

              if (typeof options.onComplete == 'function') {
                options.onComplete.call(_this, value);
              }
            }
          }
        });
      };

      $.fn.countTo.defaults = {
        from: 0, // the number the element should start at
        to: 100, // the number the element should end at
        speed: 1000, // how long it should take to count between the target numbers
        refreshInterval: 100, // how often the element should be updated
        decimals: 0, // the number of decimal places to show
        onUpdate: null, // callback method for every time the element is updated,
        onComplete: null, // callback method for when the element finishes updating
      };
    })(jQuery);

    jQuery(function ($) {
      $('.counter').countTo({
        from: 0,
        to: 20,
        speed: 5000,
        refreshInterval: 50,
        onComplete: function (value) {
          console.debug(this);
        },
      });
    });
  }

  next() {
    this.slickModal.slickNext();
  }

  prev() {
    this.slickModal.slickPrev();
  }

  redirectTrackingPage() {
    const invoice = this.invoiceFormControl.value;
    if (invoice === '') {
      this.toastr.warning('Please input invoice number to proceed tracking.');
    } else {
      this.router.navigateByUrl(
        `/track?invoice=${this.invoiceFormControl.value}`
      );
    }
  }

  openSocialLink(link: string) {
    window.open(link, '_blank');
  }

  downloadApp(device: string): void {
    if (device === 'android') {
      if (navigator.userAgent.toLowerCase().indexOf('android') > -1) {
        window.location.href = 'market://details?id=com.axp.customer';
      } else {
        window.location.href = environment.appStoreLink[device];
      }
    } else if (device === 'ios') {
      if (navigator.userAgent.toLowerCase().indexOf('ios') > -1) {
        window.location.href = 'market://details?id=com.axp.customer';
      } else {
        window.location.href = environment.appStoreLink[device];
      }
    }
  }

  setVisiblePhones(): void {
    const host = window.location.hostname;
    const parts = host.split('.');

    if (parts.length === 2 || parts[0] === 'www') {
      this.setVisiblePhonesByIP();
      return;
    }

    const subdomain = parts[0];

    switch (subdomain) {
      case 'ca':
        this.visiblePhones = [this.phoneNumbers.CA];
        break;
      case 'us':
        this.visiblePhones = [this.phoneNumbers.US];
        break;
      default:
        this.setVisiblePhonesByIP();
    }
  }

  private setVisiblePhonesByIP(): void {
    this.visiblePhones = Object.values(this.phoneNumbers);

    this.dataService.getCurrentLocation().subscribe(
      (loc) => {
        const country = (loc?.countryCode || loc?.country || loc?.country_code || '').toString().toUpperCase();
        switch (country) {
          case 'CA':
            this.visiblePhones = [this.phoneNumbers.CA];
            break;
          case 'US':
            this.visiblePhones = [this.phoneNumbers.US];
            break;
          default:
            this.visiblePhones = Object.values(this.phoneNumbers);
        }
      },
      (err) => {
        console.warn('Failed to detect location for phones', err);
        this.visiblePhones = Object.values(this.phoneNumbers);
      }
    );
  }
}
